import { Plugin, PluginKey } from 'prosemirror-state';
import { findDomRefAtPos } from 'prosemirror-utils';
import { throttle } from '../../../../lodash';
import { isTextSelection } from '../../../../utils/selection';
import { cutContentType, cutType } from '../const';
const key = new PluginKey('yfm-cut-auto-open');
export const cutAutoOpenPlugin = () => {
    return new Plugin({
        key,
        view(view) {
            update(view);
            const dragHandler = new CutAutoOpenOnDragOver(view);
            return {
                update: (view) => update(view),
                destroy: () => dragHandler.destroy(),
            };
        },
    });
};
function update(view) {
    const sel = view.state.selection;
    const domAtPos = view.domAtPos.bind(view);
    if (isTextSelection(sel)) {
        if (sel.$cursor) {
            openParentYfmCuts(sel.$cursor, domAtPos);
        }
        else {
            openParentYfmCuts(sel.$head, domAtPos);
            openParentYfmCuts(sel.$anchor, domAtPos);
        }
    }
}
function openParentYfmCuts($pos, domAtPos) {
    let { depth } = $pos;
    const { schema } = $pos.parent.type;
    while (depth > 0) {
        if ($pos.node(depth).type === cutContentType(schema)) {
            if ($pos.node(depth - 1).type === cutType(schema)) {
                const { node: cutDomNode } = domAtPos($pos.start(depth - 1), 0);
                cutDomNode.classList.add('open');
                depth--;
            }
        }
        depth--;
    }
}
class CutAutoOpenOnDragOver {
    constructor(view) {
        this._cutElem = null;
        this._timeout = null;
        this._editorView = view;
        this._docListener = throttle(this._onDocEvent.bind(this), CutAutoOpenOnDragOver.THROTTLE_WAIT);
        document.addEventListener('mousemove', this._docListener);
        document.addEventListener('dragover', this._docListener);
    }
    destroy() {
        this._clear();
        this._docListener.cancel();
        document.removeEventListener('mousemove', this._docListener);
        document.removeEventListener('dragover', this._docListener);
    }
    _onDocEvent(event) {
        const view = this._editorView;
        if (!view.dragging)
            return;
        const pos = view.posAtCoords({ left: event.clientX, top: event.clientY });
        if (!pos)
            return;
        const elem = findDomRefAtPos(pos.pos, view.domAtPos.bind(view));
        const cutElem = elem.closest(CutAutoOpenOnDragOver.YFM_CUT_SELECTOR);
        if (cutElem === this._cutElem)
            return;
        this._clear();
        if (cutElem)
            this._setCutElem(cutElem);
    }
    _clear() {
        if (this._timeout !== null)
            clearTimeout(this._timeout);
        this._timeout = null;
        this._cutElem = null;
    }
    _setCutElem(elem) {
        this._cutElem = elem;
        this._timeout = setTimeout(this._openCut.bind(this), CutAutoOpenOnDragOver.OPEN_TIMEOUT);
    }
    _openCut() {
        var _a;
        if (this._editorView.dragging) {
            (_a = this._cutElem) === null || _a === void 0 ? void 0 : _a.classList.add('open');
        }
        this._clear();
    }
}
CutAutoOpenOnDragOver.YFM_CUT_SELECTOR = '.yfm-cut:not(.open)';
CutAutoOpenOnDragOver.OPEN_TIMEOUT = 500; //ms
CutAutoOpenOnDragOver.THROTTLE_WAIT = 50; //ms
